<template>
    <Teleport to="body">
        <transition name="promo-slide">
            <div
                v-if="visible"
                class="promo-banner"
                role="region"
                :aria-label="$t('appPromotion.aria-label')"
            >
                <div class="promo-icon">
                    <img
                        src="@/assets/images/sportspoule-logo.svg"
                        alt="Sportspoule"
                    />
                </div>
                <div class="promo-text">
                    <span class="promo-title">
                        {{ $t("appPromotion.title") }}
                    </span>
                    <span class="promo-subtitle">
                        {{
                            platform === "ios"
                                ? $t("appPromotion.subtitle-ios")
                                : $t("appPromotion.subtitle-android")
                        }}
                    </span>
                </div>
                <a
                    v-if="storeUrl"
                    class="promo-cta"
                    :href="storeUrl"
                    target="_blank"
                    rel="noopener"
                >
                    {{ $t("appPromotion.cta") }}
                </a>
                <button
                    class="promo-close"
                    type="button"
                    :aria-label="$t('appPromotion.dismiss')"
                    @click="dismiss"
                >
                    &times;
                </button>
            </div>
        </transition>
    </Teleport>
</template>

<script lang="ts" setup>
    import { useAppPromotion } from "@/composables/useAppPromotion";

    const { visible, platform, storeUrl, dismiss } = useAppPromotion();
</script>

<style lang="scss" scoped>
    .promo-banner {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99998;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 12px;
        padding-top: max(8px, env(safe-area-inset-top));
        background: var(--ion-background-color, #fff);
        color: var(--color-black, #000);
        border-bottom: 1px solid var(--color-grey-200, rgba(0, 0, 0, 0.08));
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .promo-icon img {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: block;
    }

    .promo-text {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        line-height: 1.2;
    }

    .promo-title {
        font-size: 14px;
        font-weight: 700;
        color: var(--color-black, #000);
    }

    .promo-subtitle {
        font-size: 12px;
        font-weight: 500;
        color: var(--color-grey-700, #555);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .promo-cta {
        flex-shrink: 0;
        height: 32px;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: var(--color-primary, #0040ff);
        color: var(--color-always-white, #fff);
        font-size: 13px;
        font-weight: 700;
        border-radius: 16px;
        text-decoration: none;
        white-space: nowrap;

        &:active {
            transform: scale(0.97);
        }
    }

    .promo-close {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        border: none;
        background: transparent;
        color: var(--color-grey-600, #666);
        font-size: 22px;
        line-height: 1;
        cursor: pointer;
        padding: 0;
    }

    .promo-slide-enter-active,
    .promo-slide-leave-active {
        transition:
            transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
            opacity 0.3s ease;
    }

    .promo-slide-enter-from,
    .promo-slide-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }
</style>
